// extracted by mini-css-extract-plugin
export var activityContainer = "_jm-0";
export var typingIndicatorContainer = "_jm-1";
export var typingIndicatorDot = "_jm-2";
export var wave = "_jm-3";